(() => {
  if (window.dsShippingInsuranceLoaded) return;
  window.dsShippingInsuranceLoaded = true;

  const INPUT_SELECTOR = '[data-shipping-insurance]';
  const SAVE_DELAY = 80;
  const RETRY_DELAYS = [350, 900];
  const INSURANCE_PROPERTIES = {
  'Delivery Guarantee': 'Lost, stolen, or damaged — covered'
};

  let saveTimer = null;
  let requestInFlight = false;
  let lastConfirmedCart = null;

  function getInput() {
    return document.querySelector(INPUT_SELECTOR);
  }

  function getStatus() {
    return document.querySelector(
      '[data-shipping-insurance-status]'
    );
  }

  function setStatus(message = '') {
    const status = getStatus();

    if (status) {
      status.textContent = message;
    }
  }

  function setInsuranceUpdating(updating) {
    const drawer = document.getElementById('CartDrawer');

    if (!drawer) return;

    drawer.classList.toggle(
      'is-insurance-updating',
      updating
    );
  }

  function getCartUrl(endpoint) {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;

    return `${normalizedRoot}${endpoint.replace(/^\/+/, '')}`;
  }

  function formatMoney(cents, currency = 'USD') {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency
        }
      ).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  }

  function updateCheckoutTotal(cart) {
    const formattedTotal = formatMoney(
      cart.total_price,
      cart.currency || 'USD'
    );

    document
      .querySelectorAll('[data-er-cart-total-price]')
      .forEach((element) => {
        element.textContent = formattedTotal;
      });
  }

  function getInsuranceQuantity(cart, variantId) {
    return cart.items
      .filter((item) => Number(item.variant_id) === variantId)
      .reduce((total, item) => total + item.quantity, 0);
  }

  function updateCartCount(cart, variantId) {
    const insuranceQuantity =
      getInsuranceQuantity(cart, variantId);

    const visibleCount = Math.max(
      0,
      cart.item_count - insuranceQuantity
    );

    document.querySelectorAll('hdt-cart-count').forEach((element) => {
      element.textContent = visibleCount;
      element.toggleAttribute('hidden', visibleCount === 0);
    });
  }

  async function parseJsonResponse(response) {
    const responseText = await response.text();

    let data;

    try {
      data = JSON.parse(responseText);
    } catch (error) {
      const invalidResponseError = new Error(
        'Shopify returned a temporary invalid response.'
      );

      invalidResponseError.retryable = true;
      invalidResponseError.status = response.status;

      throw invalidResponseError;
    }

    if (!response.ok) {
      const requestError = new Error(
        data.description ||
        data.message ||
        'Unable to update insurance.'
      );

      requestError.retryable =
        response.status === 429 ||
        response.status >= 500;

      requestError.status = response.status;

      throw requestError;
    }

    return data;
  }

  function wait(milliseconds) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function cartSectionParameters() {
    const sectionId = document.getElementById('CartDrawer')?.getAttribute('section-id');
    return sectionId ? { sections: [sectionId], sections_url: window.location.pathname } : {};
  }

  function syncRewardSummary(cart) {
    const drawer = document.getElementById('CartDrawer');
    const sectionId = drawer?.getAttribute('section-id');
    const html = cart.sections?.[sectionId];
    if (!drawer || !html) return;
    const rendered = new DOMParser().parseFromString(html, 'text/html');
    // Refresh line indexes too: adding/removing insurance can reorder cart lines.
    for (const selector of ['.hdt-mini-cart__items', '.hdt-cart-totals-discounts', '.ds-cart-rewards']) {
      const current = drawer.querySelector(selector);
      const updated = rendered.querySelector(selector);
      if (current && updated) current.replaceWith(updated);
    }
  }

  async function updateCart(variantId, checked, attempt = 0) {
  try {
    let renderedSections;
    const currentCart = await getCurrentCart();

    const insuranceItems = (currentCart.items || []).filter(
      (item) => Number(item.variant_id) === variantId
    );

    if (checked) {
      const existingItem = insuranceItems[0];

      const endpoint = existingItem
        ? 'cart/change.js'
        : 'cart/add.js';

      const payload = existingItem
        ? {
            id: existingItem.key,
            quantity: 1,
            properties: {
              ...(existingItem.properties || {}),
              ...INSURANCE_PROPERTIES
            }
          }
        : {
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: INSURANCE_PROPERTIES
              }
            ]
          };

      const response = await fetch(getCartUrl(endpoint), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ ...payload, ...cartSectionParameters() })
      });

      renderedSections = (await parseJsonResponse(response)).sections;
    } else if (insuranceItems.length) {
      const updates = {};

      insuranceItems.forEach((item) => {
        updates[item.key] = 0;
      });

      const response = await fetch(getCartUrl('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates, ...cartSectionParameters() })
      });

      renderedSections = (await parseJsonResponse(response)).sections;
    } else {
      return currentCart;
    }

    const updatedCart = await getCurrentCart();
    return { ...updatedCart, sections: renderedSections };
  } catch (error) {
    const canRetry =
      attempt < RETRY_DELAYS.length &&
      (error.retryable === true || error instanceof TypeError);

    if (canRetry) {
      await wait(RETRY_DELAYS[attempt]);
      return updateCart(variantId, checked, attempt + 1);
    }

    throw error;
  }
}

  async function getCurrentCart() {
    const response = await fetch(getCartUrl('cart.js'), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    });

    return parseJsonResponse(response);
  }

  function syncConfirmedCart(
    cart,
    variantId,
    options = {}
  ) {
    const input = getInput();

    if (!input) return;

    const serverChecked =
      getInsuranceQuantity(cart, variantId) > 0;

    input.dataset.confirmed = String(serverChecked);
    input.dataset.cartTotal = String(cart.total_price);
    input.dataset.currency =
      cart.currency ||
      input.dataset.currency ||
      'USD';

    if (options.updateCheckbox !== false) {
      input.checked = serverChecked;
    }

    if (options.updateTotal !== false) {
      updateCheckoutTotal(cart);
      syncRewardSummary(cart);
    }

    updateCartCount(cart, variantId);
    lastConfirmedCart = cart;
  }

  function scheduleSave(delay = SAVE_DELAY) {
    window.clearTimeout(saveTimer);

    saveTimer = window.setTimeout(() => {
      commitInsuranceState();
    }, delay);
  }

  async function commitInsuranceState() {
  const input = getInput();

  if (!input) {
    setInsuranceUpdating(false);
    return;
  }

  /*
   * Nếu request trước vẫn chạy thì giữ nguyên progress.
   * Khi request đó hoàn tất, finally sẽ lưu trạng thái cuối.
   */
  if (requestInFlight) return;

  const variantId = Number(input.dataset.variantId);
  const confirmedState =
    input.dataset.confirmed === 'true';
  const requestedState = input.checked;

  /*
   * Khách đã bấm trở lại đúng trạng thái ban đầu
   * trước khi request được gửi.
   */
  if (requestedState === confirmedState) {
    setInsuranceUpdating(false);
    return;
  }

  if (!variantId) {
    input.checked = confirmedState;
    setInsuranceUpdating(false);
    setStatus(
      'Unable to update insurance. Please try again.'
    );
    return;
  }

  requestInFlight = true;
  setStatus('');

  const wrapper =
    input.closest('.ds-shipping-insurance');

  wrapper?.setAttribute('aria-busy', 'true');

  try {
    const cart = await updateCart(
      variantId,
      requestedState
    );

    const currentInput = getInput();

    if (!currentInput) return;

    const customerChangedAgain =
      currentInput.checked !== requestedState;

    /*
     * Lưu trạng thái thật Shopify trả về.
     * Nếu khách đã đổi lựa chọn lần nữa thì chưa hiển thị
     * Total trung gian.
     */
    syncConfirmedCart(cart, variantId, {
      updateCheckbox: !customerChangedAgain,
      updateTotal: !customerChangedAgain
    });

    setStatus('');
    } catch (error) {
    console.error(
      'Shipping protection error:',
      error
    );

    /*
     * Response có thể lỗi nhưng Shopify vẫn đã cập nhật cart.
     * Đọc lại trạng thái thật trước khi báo lỗi cho khách.
     */
    try {
      const recoveredCart = await getCurrentCart();

      const recoveredChecked =
        getInsuranceQuantity(
          recoveredCart,
          variantId
        ) > 0;

      syncConfirmedCart(recoveredCart, variantId, {
        updateCheckbox: true,
        updateTotal: true
      });

      /*
       * Shopify đã nhận đúng lựa chọn của khách:
       * coi là thành công và không hiện lỗi giả.
       */
      if (recoveredChecked === requestedState) {
        setStatus('');
      } else {
        setStatus(
          'Unable to update protection. Please try again.'
        );
      }
    } catch (recoveryError) {
      console.error(
        'Shipping protection recovery error:',
        recoveryError
      );

      const currentInput = getInput();

      if (currentInput) {
        currentInput.checked =
          currentInput.dataset.confirmed === 'true';
      }

      if (lastConfirmedCart) {
        updateCheckoutTotal(lastConfirmedCart);
      }

      setStatus(
        'Unable to update protection. Please try again.'
      );
    }
  } finally {
    requestInFlight = false;

    const currentInput = getInput();

    currentInput
      ?.closest('.ds-shipping-insurance')
      ?.removeAttribute('aria-busy');

    const needsAnotherSave =
      currentInput &&
      currentInput.checked !==
        (currentInput.dataset.confirmed === 'true');

    /*
     * Nếu khách đổi lựa chọn trong lúc request đang chạy,
     * giữ progress và tiếp tục lưu lựa chọn cuối cùng.
     */
    if (needsAnotherSave) {
      scheduleSave();
    } else {
      setInsuranceUpdating(false);
    }
  }
}

  document.addEventListener('change', (event) => {
    const input = event.target.closest(INPUT_SELECTOR);

    if (!input) return;

  /*
   * Hiện progress ngay khi checkbox thay đổi,
   * bao gồm cả thời gian debounce 80ms.
   */
    setInsuranceUpdating(true);
    setStatus('');
    scheduleSave();
  });
})();
/* ===== CHECKOUT SPINNER FEEDBACK ===== */

(() => {
  if (window.dsCheckoutSpinnerLoaded) return;
  window.dsCheckoutSpinnerLoaded = true;

  const BUTTON_SELECTOR =
    '#CartDrawer .hdt-mini-cart__btn-checkout[name="checkout"]';

  function resetCheckoutButton(button) {
    if (!button) return;

    const form = button.closest('form');

    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');

    if (form) {
      delete form.dataset.checkoutSubmitting;
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('#CartDrawer')) return;
    if (event.defaultPrevented) return;

    const button =
      event.submitter?.matches?.(BUTTON_SELECTOR)
        ? event.submitter
        : form.querySelector(
            '.hdt-mini-cart__btn-checkout[name="checkout"]'
          );

    if (!button) return;

    /*
     * Chặn submit lặp lại nhưng không dùng disabled,
     * vì Shopify cần nhận name="checkout".
     */
    if (form.dataset.checkoutSubmitting === 'true') {
      event.preventDefault();
      return;
    }

    form.dataset.checkoutSubmitting = 'true';

    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');

    /*
     * Nếu một validation khác chặn submit,
     * trả nút về bình thường.
     */
    window.setTimeout(() => {
      if (event.defaultPrevented) {
        resetCheckoutButton(button);
      }
    }, 0);

    /*
     * Nếu checkout không chuyển trang do lỗi mạng,
     * cho phép khách bấm lại sau 12 giây.
     */
    window.setTimeout(() => {
      if (document.contains(button)) {
        resetCheckoutButton(button);
      }
    }, 12000);
  });

  /*
   * Reset khi khách bấm Back từ trang Checkout.
   */
  window.addEventListener('pageshow', () => {
    document
      .querySelectorAll(BUTTON_SELECTOR)
      .forEach(resetCheckoutButton);
  });
})();